import { createGetApi, createPostApi } from 'friday-async';

class Apis {
  public list = createGetApi<void>({
    url: '/bottomMenu/list',
  });

  public create = createPostApi<{
    title: string;
    icon?: string;
    linkUrl: string;
    sortOrder?: number;
    status?: string;
  }>({
    url: '/bottomMenu/create',
  });

  public update = createPostApi<{
    _id: string;
    title: string;
    icon?: string;
    linkUrl: string;
    sortOrder?: number;
    status?: string;
  }>({
    url: '/bottomMenu/update',
  });

  public remove = createPostApi<{_id: string}>({
    url: '/bottomMenu/remove',
  });
}

export default Apis;
